import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Form, Button, InputGroup } from "react-bootstrap";
//import { createCustomer } from "../services/createCustomer";

import axios from "axios";
import { environment } from "../../environment";
//import Loader from "../Components/Loader";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
// import { Form, InputGroup } from "react-bootstrap";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NavbarNew from "../Components/NavbarNew";
const MySwal = withReactContent(Swal);

const ChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [key, setKey] = useState("Profile");
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const togglePasswordVisibility = (field) => {
    if (field === "currentPassword") {
      setShowCurrentPassword(!showCurrentPassword);
    } else if (field === "newPassword") {
      setShowNewPassword(!showNewPassword);
    } else if (field === "confirmPassword") {
      setShowConfirmPassword(!showConfirmPassword);
    }
  };
  const handleCancel = () => {
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setShowCurrentPassword(false);
    setShowNewPassword(false);
    setShowConfirmPassword(false);
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    // if (currentPassword) {
    if (newPassword === confirmPassword) {
      await axios
        .post(
          environment.apiUrl + "auth/changePassword",
          { currentPassword: currentPassword, newPassword: newPassword },
          {
            headers: {
              "X-Authorization": "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.response?.data?.message) {
            MySwal.fire({
              title: <p>{res.response.data.message}</p>,
              type: "success",
            });
          } else {
            MySwal.fire({
              title: <p>Password has been changed successfully</p>,
              type: "success",
            });
            handleCancel();
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("refreshToken", res.data.refreshToken);
          }
        })
        .catch((err) => {
          MySwal.fire({
            title: <p>{err?.response?.data?.message || "Failed"}</p>,
            type: "error",
          });
        });
    } else {
      MySwal.fire({
        title: <p>Passwords Don't match</p>,
        type: "error",
      });
    }
    // } else {
    //   MySwal.fire({
    //     title: <p>Please enter your password</p>,
    //     type: "error",
    //   });
    // }

    // axios
    //   .post(
    //     environment.apiUrl + "auth/changePassword",
    //     { currentPassword: currentPassword, newPassword: newPassword },
    //     {
    //       headers: {
    //         "X-Authorization": "Bearer " + localStorage.getItem("token"),
    //       },
    //     }
    //   )
    //   .then(() => {
    //     console.log("password changed");
    //     MySwal.fire({
    //       title: <p>Password has been changed successfully</p>,
    //       type: "success",
    //     });
    //     window.alert("password changed");
    //   })
    //   .catch((err) => {
    //     MySwal.fire({
    //       title: <p>{err.message}</p>,
    //       type: "error",
    //     });
    //     console.log("error in changing password");
    //   });
  };
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  // console.log("GGGGGGGGGGGGGGGGGGGGGGGGGGGG", userDetails.data.firstName);
  return (
    <>
      <div className="container-fluid">
        <NavbarNew />
        <div className="row">
          <div className="col-lg-3"></div>
          <div className="col-md-6 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <Form onSubmit={submitHandler}>
                  <Form.Group controlId="title">
                    <Form.Label>
                      * <b>Current Password</b>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={showCurrentPassword ? "text" : "password"}
                        placeholder="Enter current password"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                      />
                      <InputGroup.Append>
                        <InputGroup.Text
                          onClick={() =>
                            togglePasswordVisibility("currentPassword")
                          }
                        >
                          <FontAwesomeIcon
                            icon={showCurrentPassword ? faEye : faEyeSlash}
                          />
                        </InputGroup.Text>
                      </InputGroup.Append>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group controlId="name" style={{ marginTop: "50px" }}>
                    <Form.Label>
                      * <b>Set New Password</b>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={showNewPassword ? "text" : "password"}
                        placeholder="Enter New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                      <InputGroup.Append>
                        <InputGroup.Text
                          onClick={() =>
                            togglePasswordVisibility("newPassword")
                          }
                        >
                          <FontAwesomeIcon
                            icon={showNewPassword ? faEye : faEyeSlash}
                          />
                        </InputGroup.Text>
                      </InputGroup.Append>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group controlId="name" style={{ marginTop: "50px" }}>
                    <Form.Label>
                      * <b>Re-enter New Password</b>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Enter Password Again"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                      <InputGroup.Append>
                        <InputGroup.Text
                          onClick={() =>
                            togglePasswordVisibility("confirmPassword")
                          }
                        >
                          <FontAwesomeIcon
                            icon={showConfirmPassword ? faEye : faEyeSlash}
                          />
                        </InputGroup.Text>
                      </InputGroup.Append>
                    </InputGroup>
                  </Form.Group>
                  <div
                    className="row col-md-12 mt-10"
                    style={{ marginTop: "50px" }}
                  >
                    <div className="col-md-6">
                      <Button
                        type="submit"
                        className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                      >
                        Update Change
                      </Button>
                    </div>
                    <div className="col-md-6">
                      <Button
                        className="btn btn-block btn-light btn-lg font-weight-medium auth-form-btn"
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
          <div className="col-lg-3"></div>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
